import { Brand } from 'src/app/components/company/models/new/brand.model';
import { Category } from './category';
import { StyleGroup } from './style-group';
import { StyleDescription } from './style-description';
import { Collection } from './collection';
import { Purpose } from './purpose';
import { Team } from './team';
import { PaginationFilters } from './paginationFilters';
import { Status } from './status';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { Order } from './order';
import { Selectable } from 'src/app/shared/types/selectable.type';

export class Style {
	brand?: Brand;
	category?: Category;
	modelId?: number;
	code?: string;
	name?: string;
	colors?: Color[];
	styleGroup?: StyleGroup;
	styleDescription?: StyleDescription;
	collection?: Collection;

	gender?: Gender;
	teams?: Team[];
	status?: Status;
	warehouse?: Warehouse;
	orders?: Order[];
	warehouseArticles?: WarehouseArticle[];

	constructor(init?: Partial<Style>) {
		Object.assign(this, init);
	}
}

export class Size {
	id?: number;
	name?: string;
	ean?: string;
	constructor(init?: Partial<Size>) {
		Object.assign(this, init);
	}
}

export class WarehouseArticle {
	id?: number;
	availableQty?: number;
	operationType?: string;
	color?: Color;
	size?: Size;
	warehouse?: Warehouse;

	constructor(init?: Partial<WarehouseArticle>) {
		Object.assign(this, init);
	}
}

export enum StyleStatus {
	MissingImages = 1,
	Shooting = 2,
	Confirmed = 3
	//Published = 4  //da definire se serve
}

export class Gender {
	id?: number;
	name?: string;
	constructor(init?: Partial<Gender>) {
		Object.assign(this, init);
	}
}

export class Color {
	id?: number;
	code?: string;
	name?: string;
	default?: boolean;
	size?: Size;
	//estimatedCost?: number;

	constructor(init?: Partial<Color>) {
		Object.assign(this, init);
	}
}

export class SizeGroup {
	id?: number;
	name?: string;

	constructor(init?: Partial<SizeGroup>) {
		Object.assign(this, init);
	}
}

export class StyleFilters extends PaginationFilters {
	brands?: Brand[];
	categories?: Category[];
	styleGroups?: StyleGroup[];
	styleCode?: string;
	styleDescriptions?: StyleDescription[];
	collections?: Collection[];
	purposes?: Purpose[];
	genders?: Gender[];
	statuses?: Status[];
	teams?: Team[];
	warehouses?: Warehouse[];

	constructor(init?: Partial<StyleFilters>) {
		super(init);
		Object.assign(this, init);
	}
}
